import {DocumentTypeIdContext} from '../../../../Main/Forms/CanvasFormContainer';
import React, {useContext, useState} from 'react';
import styled from 'styled-components';
import BodyKnowledgeDescriptionContentSide from '../BodyKnowledgeDescriptionContentSide';
import {CardTypes, formBodyType} from '../../../../../util/uiconstants';
import {labels, GetCardTypeForBody} from '../../../../../util/utils';
import {createRequestURL, createUpdatePayloadForMultiSelectBody} from '../Common/BodyResponseUtility';
import EllipsesControl from '../../../../Common/EllipsesControl/EllipsesControl';
import ProgressBar from '../../../BaseComponentWrappers/MotifProgressBar';
import ToggleSwitch from '../../../BaseComponentWrappers/MotifToggleSwitch';
import {useSelector} from 'react-redux';
import {getOptionsForFormBody} from '../../../../../selectors/Ares/selectors';
import BodyKnowledgeDescription from '../BodyKnowledgeDescription';
import {useDocumentId, useEngagementId} from '../../../../../util/customHooks';

export default function ToggleSwitchTwoOptionsBody({
	isAresView,
	showGuidance,
	guidanceFilter,
	bodyRelatedData,
	headerId,
	sectionId,
	bodyId,
	updateBodyOptions,
	getBodiesBySectionId,
	isSnapshotView
}) {
	const [toggleSwitchData, setToggleSwitchData] = useState(
		bodyRelatedData?.optionsAndResponses.map((obj) => ({
			...obj,
			isChecked: isSnapshotView ? obj.bodySelectedOptionId : obj.bodyOptionId === obj.bodySelectedOptionId
		}))
	);
	const engagementId = useEngagementId(),
		documentTypeId = useContext(DocumentTypeIdContext),
		documentId = useDocumentId(),
		formBodyBorder = GetCardTypeForBody(bodyRelatedData, isAresView);

	const leftOption = useSelector((state) => getOptionsForFormBody(state, sectionId, bodyId)?.optionsAndResponses[0]);
	const rightOption = useSelector((state) => getOptionsForFormBody(state, sectionId, bodyId)?.optionsAndResponses[1]);

	const checkChange = (e) => {
		if (isSnapshotView) {
			return;
		}
		let changed = rightOption.bodyOptionId;

		if (rightOption.bodySelectedOptionId) {
			changed = leftOption.bodyOptionId;
		}

		if (toggleSwitchData && toggleSwitchData.length > 0) {
			toggleSwitchData.map((data) => {
				if (data.bodyOptionId === Number(changed)) {
					data.isChecked = true;
				} else {
					data.isChecked = false;
				}
			});
			setToggleSwitchData(toggleSwitchData);
		}

		const bodyResponseObject = createUpdatePayloadForMultiSelectBody(
			formBodyType.ToggleSwitchTwoOptions,
			toggleSwitchData
		);
		document.getElementById(bodyId).classList.add('greyOutArea');

		updateBodyOptions(
			bodyId,
			changed,
			createRequestURL(engagementId, documentId, headerId, sectionId, bodyId, documentTypeId),
			bodyResponseObject
		);
	};

	const labelSelector = (option, className) => (
		<section className={className}>
			<EllipsesControl
				content={option?.bodyOptionText}
				tooltip={option?.bodyOptionText}
				noOfLines={1}
				tooltipClass="tooltipCustomWidth ToggleSwitchTwoOptionsTooltip"
			/>
		</section>
	);

	const toggleSwitchBodyContent = (
		<>
			<section className="SectionBodyData ToggleSwitchListBodyData" id={bodyId}>
				<section className="MotifProgressBarWrapper">
					<ProgressBar isIndeterminate showLabel labelComponent={<span>{labels.saving}</span>} />
				</section>
				<section className="ToggleSwitchColumnWrapper">
					<section className="switch-column">
						<ToggleSwitch
							checked={rightOption && rightOption.bodySelectedOptionId > 0}
							onChange={checkChange}
							offLabel={labelSelector(leftOption, 'left-option')}
							onLabel={labelSelector(rightOption, 'right-option')}
							id={`toggle-${bodyId}`}
						/>
					</section>
				</section>
			</section>
		</>
	);

	return (
		<Wrapper className={`SectionBodyWrapper SectionBodySlider SectionBodyToggleSwitch ${formBodyBorder}`}>
			<StyledToggleSwitchTwoOptionsBody className="StyledToggleSwitchListContainer">
				{bodyRelatedData?.cardTypeId === CardTypes.DefaultView && isAresView ? (
					<>
						<BodyKnowledgeDescription
							isAresView={isAresView}
							isSnapshotView={isSnapshotView}
							bodyModel={bodyRelatedData}
							engagementId={engagementId}
							documentId={documentId}
							headerId={headerId}
							sectionId={sectionId}
							bodyId={bodyId}
							bodyDescriptionText={bodyRelatedData?.name}
							isCustom={bodyRelatedData?.isCustom}
							isDuplicate={bodyRelatedData?.isDuplicate}
							getBodiesBySectionId={getBodiesBySectionId}
							showGuidance={showGuidance}
							guidanceFilter={guidanceFilter}
						/>
						{toggleSwitchBodyContent}
					</>
				) : (
					<BodyKnowledgeDescriptionContentSide
						isAresView={isAresView}
						isSnapshotView={isSnapshotView}
						bodyModel={bodyRelatedData}
						engagementId={engagementId}
						documentId={documentId}
						headerId={headerId}
						sectionId={sectionId}
						bodyId={bodyId}
						bodyDescriptionText={bodyRelatedData?.name}
						isCustom={bodyRelatedData?.isCustom}
						isDuplicate={bodyRelatedData?.isDuplicate}
						getBodiesBySectionId={getBodiesBySectionId}
						showGuidance={showGuidance}
						guidanceFilter={guidanceFilter}
					>
						{toggleSwitchBodyContent}
					</BodyKnowledgeDescriptionContentSide>
				)}
			</StyledToggleSwitchTwoOptionsBody>
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: block;
	&.SectionBodySlider {
		min-height: var(--px-110);
	}
	&.DefaultView {
		.ToggleSwitchListBodyData {
			background-color: var(--neutrals-00white);
			border: var(--px-1) solid var(--neutrals-200);
			border-radius: var(--px-12) !important;
			padding: var(--px-24);
			margin-top: var(--px-24);
			width: 100%;
		}
	}
	.SectionBodyData {
		flex-direction: unset !important;
		padding: 0;
		width: var(--px-300);
		text-align: end;
		position: relative;
		&.ToggleSwitchListBodyData {
			margin-top: var(--px-16);
		}
		.MotifProgressBarWrapper {
			display: none;
			position: absolute;
			justify-content: center;
			width: 80%;
			height: auto;
			top: var(--px-34);
			.motif-progress-bar-wrapper {
				height: 100%;
				width: 30%;
				z-index: 1;
				justify-content: center;
				span {
					color: var(--green-500);
					font-size: var(--px-12);
				}
				.motif-progress {
					background-color: var(--green-500);
				}
				svg path {
					fill: transparent !important;
				}
			}
		}
		.ToggleSwitchColumnWrapper {
			display: flex;
			width: 100%;
			.switch-column {
				display: inline-flex;
				width: 100%;
				height: var(--px-24);
				margin: 0;
				.motif-toggle-switch-wrapper {
					width: 100%;
					.motif-toggle-switch-off-text,
					.motif-toggle-switch-on-text {
						width: auto;
						max-width: 40%;
					}
					.left-option,
					.right-option {
						width: 100%;
						display: flex;
					}
				}
			}
			.options-column {
				display: inline-flex;
				width: var(--px-230);
			}
		}
	}
`;

const StyledToggleSwitchTwoOptionsBody = styled.section`
	.SectionBodyDescription {
		display: flex;
		justify-content: space-between;
		.SectionBodyDescriptionWrapper {
			width: calc(100% - var(--px-140)) !important;
			.section-showless-header {
				width: calc(100% - var(--px-300)) !important;
				margin-right: 0;
			}
			.SectionBodyDataWrapper {
				width: var(--px-300) !important;
			}
		}
		.sectionBodyRightIcons {
			width: var(--px-140) !important;
		}
	}
`;
